import findUser from "@/actions/findUser";
import updateUser from "@/actions/updateUser";
import socket from "@/socket";

export default async function notify({
  userId,
  type,
  message,
}: {
  userId: string;
  type: string;
  message: string;
}) {
  const user = await findUser(userId);
  
  if (!user) return;

  const notificationData = { message, type };
  if (socket) {
    socket.emit("notificationEvent", {
      ...notificationData,
      userId,
    });
  }

  return await updateUser({
    notifications: {
      create: notificationData,
    },
  });
}
